class StickyNavbar extends window.HTMLElement {
    connectedCallback() {
        this.header = this
        this.header.classList.add("top-0", "transition-all", "relative")
        this.headerBounds = {}
        this.currentScrollTop = 0
        this.scrollLimit = 4
        this.preventReveal = false
        this.onScrollHandler = this.onScroll.bind(this)
        this.hideHeaderOnScrollUp = () => {
            this.preventReveal = true
        }

        window.addEventListener("scroll", this.onScrollHandler, false)

        this.createObserver()
        this.setupCSS()
    }

    setupCSS() {
        document.addEventListener("DOMContentLoaded", function () {
            const header = document.querySelector("header")
            const headerHeight = header.offsetHeight
            console.log(headerHeight, "headerHeight")
            document.documentElement.style.setProperty(
                "--header-height",
                `${headerHeight}px`
            )

            const headerGroup = document.querySelector("#headerGroup")
            const headerGroupHeight = headerGroup.offsetHeight
            document.documentElement.style.setProperty(
                "--header-group-height",
                `${headerGroupHeight}px`
            )
        })
    }

    createObserver() {
        const observer = new window.IntersectionObserver(
            (entries, observer) => {
                this.headerBounds = entries[0].intersectionRect
                observer.disconnect()
            }
        )

        observer.observe(this.header)
    }

    onScroll() {
        const scrollTop =
            window.pageYOffset || document.documentElement.scrollTop

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return

        if (
            scrollTop > this.currentScrollTop + this.scrollLimit &&
            scrollTop > this.headerBounds.bottom
        ) {
            if (this.preventHide) return
            window.requestAnimationFrame(this.hide.bind(this))
        } else if (
            scrollTop < this.currentScrollTop - this.scrollLimit &&
            scrollTop > this.headerBounds.bottom
        ) {
            if (!this.preventReveal) {
                window.requestAnimationFrame(this.reveal.bind(this))
            } else {
                window.clearTimeout(this.isScrolling)

                this.isScrolling = setTimeout(() => {
                    this.preventReveal = false
                }, 66)

                window.requestAnimationFrame(this.hide.bind(this))
            }
        } else if (scrollTop <= this.headerBounds.top) {
            window.requestAnimationFrame(this.reset.bind(this))
        }

        this.currentScrollTop = scrollTop
    }

    hide() {
        this.header.classList.add("hide-navbar")
    }

    reveal() {
        this.header.classList.remove("hide-navbar")
    }

    reset() {
        this.header.classList.remove("hide-navbar")
    }
}

window.customElements.define("sticky-navbar", StickyNavbar);

document.addEventListener("DOMContentLoaded", function() {
    const menuItems = document.querySelectorAll('.has-children');
    // Short delay before closing, so the cursor can cross small gaps
    // between the nav link and the mega menu without it disappearing.
    const CLOSE_DELAY = 150;
    const closeTimers = new Map();

    const openMenu = (menu) => {
        clearTimeout(closeTimers.get(menu));
        // Close any other open mega menu right away so they never overlap
        closeTimers.forEach((timer, otherMenu) => {
            if (otherMenu !== menu) {
                clearTimeout(timer);
                otherMenu.classList.remove('show-drop-down');
            }
        });
        menu.classList.add('show-drop-down');
    };

    const closeMenu = (menu) => {
        clearTimeout(closeTimers.get(menu));
        closeTimers.set(menu, setTimeout(() => {
            menu.classList.remove('show-drop-down');
        }, CLOSE_DELAY));
    };

    menuItems.forEach(item => {
        const childMenuId = item.dataset.childMenu;
        const childMenu = document.querySelector(`#child-menu-${childMenuId}`);

        if (childMenu) {
            closeTimers.set(childMenu, null);

            item.addEventListener('mouseenter', () => openMenu(childMenu));
            item.addEventListener('mouseleave', () => closeMenu(childMenu));
            childMenu.addEventListener('mouseenter', () => openMenu(childMenu));
            childMenu.addEventListener('mouseleave', () => closeMenu(childMenu));

            const searchInput = childMenu.querySelector('input[type="search"]');
            const crossIcon = childMenu.querySelector('.search-bar-cross');

            if (searchInput) {
                searchInput.addEventListener('input', function() {
                    if (searchInput.value.length > 0) {
                        childMenu.classList.add('active-search-bar');
                        crossIcon.style.display = 'block';
                    } else {
                        childMenu.classList.remove('active-search-bar');
                        crossIcon.style.display = 'none';
                    }
                });

                searchInput.addEventListener('focus', function() {
                    if (searchInput.value.length > 0) {
                        childMenu.classList.add('active-search-bar');
                    }
                });
            }

            if (crossIcon) {
                crossIcon.addEventListener('click', function() {
                    searchInput.value = '';
                    searchInput.focus();
                    childMenu.classList.remove('active-search-bar');
                });
            }
        }
    });

    const navLinks = document.querySelectorAll('[data-nav-link]');

    navLinks.forEach(link => {
        link.addEventListener('mouseenter', function() {
            const productHandle = link.getAttribute('data-prod-handle');
            const targetImage = document.querySelector(`[data-image-id="${productHandle}"]`);

            if (targetImage) {
                targetImage.classList.add("!opacity-100");
            }
        });

        link.addEventListener('mouseleave', function() {
            const productHandle = link.getAttribute('data-prod-handle');
            const targetImage = document.querySelector(`[data-image-id="${productHandle}"]`);

            if (targetImage) {
                targetImage.classList.remove("!opacity-100");
            }
        });
    });
});